import { type ValueOf } from '@dni-types/utilities/value-of'

export const CarrierValidationStatus = {
  EMPTY: 'empty',
  INCOMPLETE: 'incomplete',
  FORMAT_ERROR: 'format_error',
  VALIDATING: 'validating',
  VALID: 'valid',
  NOT_FOUND: 'not_found',
  SYSTEM_ERROR: 'system_error',
} as const

export type CarrierValidationStatusType = ValueOf<typeof CarrierValidationStatus>
